import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { getTrackByFn } from '@y42/angular/util';
import { IconModule } from '@y42/core/icon';
import { SelectOptionType, SingleSelectComponent } from '@y42/core/select';
import { UserColorScheme } from './user-color-scheme.enum';

interface AppTheme {
  name: string;
  value: UserColorScheme;
  icon: IconName;
}

@Component({
  selector: 'y42-user-color-scheme[formCtrl]',
  templateUrl: './user-color-scheme.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, IconModule, SingleSelectComponent, ReactiveFormsModule],
})
export class UserColorSchemeComponent {
  @Input() formCtrl!: FormControl<UserColorScheme>;

  readonly appThemeOptions: AppTheme[] = [
    { name: 'Light', value: UserColorScheme.Light, icon: 'lightbulb-on' },
    { name: 'Dark', value: UserColorScheme.Dark, icon: 'moon-stars' },
    { name: 'System Default', value: UserColorScheme.System, icon: 'desktop' },
  ];

  readonly trackByValueField = getTrackByFn<AppTheme>('value');
  readonly selectOptionType!: SelectOptionType<AppTheme>;
}
